import React from 'react';

import InsuranceExclusions from '../../components/Monitoring/InsuranceExclusions';

function InsuranceExclusionsView() {
  return <InsuranceExclusions />;
}

export default InsuranceExclusionsView;
